(() => {
  'use strict';
  if (window.FizzyAnnouncementSlider) return;

  // The native announcement module owns init/unload, breakpoints and sticky offsets.
  window.FizzyAnnouncementSlider = class {
    constructor(element) {
      this.element = element;
      this.slides = Array.from(element.querySelectorAll('.announcement-slider__slide'));
      this.wrapper = element.closest('.slideshow-wrapper');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      this.index = 0;
      this.interval = Math.min(10000, Math.max(2000, Number(element.dataset.interval) || 4000));
      this.paused = element.dataset.fizzyTouchPaused === 'true';
      this.hovered = false;
      this.timer = null;
      const options = { signal: this.controller.signal };
      this.wrapper.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.wrapper.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.wrapper.addEventListener('focusin', () => this.schedule(), options);
      // A touch on the message stops rotation for the rest of this page view, without swallowing links.
      this.element.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') {
          this.element.dataset.fizzyTouchPaused = 'true';
          this.pause();
        }
      }, { ...options, passive: true });
      this.wrapper.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.configure(), options);
      this.configure();
    }

    configure() {
      const rotating = this.slides.length > 1 && !this.motion.matches;
      this.element.classList.add('fizzy-announcement');
      this.element.classList.toggle('fizzy-announcement--static', !rotating);
      this.wrapper.classList.toggle('fizzy-announcement-wrapper', rotating);
      this.slides.forEach((slide, index) => {
        slide.classList.remove('is-leaving', 'is-entering');
        slide.classList.toggle('is-current', index === this.index);
        this.setAvailable(slide, !rotating || index === this.index);
      });
      this.schedule();
    }

    setAvailable(slide, available) {
      slide.inert = !available;
      if (available) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
    }

    goToSlide(index) {
      if (index === this.index || !this.slides[index]) return;
      const previous = this.slides[this.index];
      this.slides.forEach(slide => slide.classList.remove('is-current', 'is-entering', 'is-leaving'));
      this.index = index;
      if (!this.motion.matches && this.element.dataset.animation !== 'none') {
        previous.classList.add('is-leaving');
        this.slides[index].classList.add('is-entering');
      }
      this.slides[index].classList.add('is-current');
      this.slides.forEach((slide, position) => this.setAvailable(slide, this.motion.matches || position === index));
    }

    schedule() {
      clearTimeout(this.timer);
      this.timer = null;
      if (this.controller.signal.aborted || this.paused || this.hovered || this.motion.matches ||
          this.slides.length < 2 || document.hidden || this.wrapper.contains(document.activeElement)) return;
      this.timer = setTimeout(() => {
        this.goToSlide((this.index + 1) % this.slides.length);
        this.schedule();
      }, this.interval);
    }

    pause() {
      this.paused = true;
      this.schedule();
    }

    play() {
      this.paused = this.element.dataset.fizzyTouchPaused === 'true';
      this.schedule();
    }

    destroy() {
      this.controller.abort();
      clearTimeout(this.timer);
      this.element.classList.remove('fizzy-announcement', 'fizzy-announcement--static');
      this.wrapper.classList.remove('fizzy-announcement-wrapper');
      this.slides.forEach(slide => {
        slide.classList.remove('is-current', 'is-entering', 'is-leaving');
        this.setAvailable(slide, true);
      });

    }
  };

  document.addEventListener('keydown', event => {
    const market = event.target.closest('.fizzy-announcement-market[open]');
    if (event.key === 'Escape' && market) {
      market.open = false;
      market.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.fizzy-announcement-market[open]').forEach(market => {
      if (!market.contains(event.target)) market.open = false;
    });
  });

  // Announcement is its own section; the header's lifecycle does not cover its editor events.
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('#AnnouncementSlider')) window.theme?.announcementBar?.init();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('#AnnouncementSlider')) window.theme?.announcementBar?.unload();
  });
  document.addEventListener('shopify:block:select', event => {
    if (event.target.closest('#AnnouncementSlider')) window.theme?.announcementBar?.onBlockSelect(event.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', event => {
    if (event.target.closest('#AnnouncementSlider')) window.theme?.announcementBar?.onBlockDeselect();
  });
})();
